const mutations = {
  SET_LANGUAGE(state, lang) {
    window.localStorage.setItem('language', lang)
    state.language = lang;
  }
}

export default mutations